"use client";

import { cn } from "@/lib/utils";
import { MediaLayoutBlock as MediaLayoutBlockType } from "@/lib/utils/lomdaV3/types";
import { useBlockEditable } from "../../../hooks/useBlockEditable";
import { useResolvedGridGap } from "../../../hooks/useGridGap";
import { gridColsClass, mediaWidthPct } from "../../../lib/blockRegistry";
import MediaCell from "./mediaCell";

export default function MediaLayoutBlock({
    block,
}: {
    block: MediaLayoutBlockType;
}) {
    const editable = useBlockEditable();
    const gridGap = useResolvedGridGap(block.id);
    const { position, width, cells } = block.data;
    const isGrid = cells.length > 1;

    return (
        <div className="relative flex flex-col gap-2">
            {isGrid ? (
                <div
                    className={cn(
                        "grid grid-cols-1",
                        gridColsClass(cells.length)
                    )}
                    style={{ gap: gridGap }}
                >
                    {cells.map((_, i) => (
                        <MediaCell
                            key={i}
                            block={block}
                            index={i}
                            position={position}
                            showCaption={position !== "none"}
                            isGrid
                            editable={editable}
                        />
                    ))}
                </div>
            ) : (
                <div
                    className="mx-auto w-full"
                    style={{ maxWidth: `${mediaWidthPct(width)}%` }}
                >
                    <MediaCell
                        block={block}
                        index={0}
                        position={position}
                        showCaption={position !== "none"}
                        isGrid={false}
                        editable={editable}
                    />
                </div>
            )}
        </div>
    );
}
